<img src="/assets/images/logo_trans.png" alt="Caliber Logo" class={$$props.class}>
